import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanyCreditsTab } from '../../../-components/CompanyCreditsTab';
import {
  companyCreditBalanceQueryOptions,
  companyCreditTransactionsQueryOptions,
} from '../../../-hooks/useCompanyCredits';
import { DEFAULT_PAGE_SIZE } from '../../../-utils/pagination';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/credits/',
)({
  // Both: the cards and the ledger are two reads behind one tab.
  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData(
        companyCreditBalanceQueryOptions(params.companyId),
      ),
      queryClient.ensureQueryData(
        companyCreditTransactionsQueryOptions({
          companyId: params.companyId,
          page: 1,
          limit: DEFAULT_PAGE_SIZE,
        }),
      ),
    ])
      // A failed prefetch must not blank the tab — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CompanyCreditsPage,
});

function CompanyCreditsPage() {
  const { companyId } = Route.useParams();
  return <CompanyCreditsTab companyId={companyId} />;
}
